import { handlers } from './handlers'

/** Enable mocks depending on env variables. */
export const enableMocks = async () => {
    if (
        process.env.NODE_ENV !== 'development' ||
        process.env.REACT_APP_MOCKING_ENABLED !== 'true'
    )
        return

    const isServer = window === undefined

    // Server
    if (isServer) {
        const { setupServer } = await import('msw/node')

        setupServer(...handlers).listen()
    }

    // Browser
    if (!isServer) {
        const { setupWorker } = await import('msw/browser')

        await setupWorker(...handlers).start({
            onUnhandledRequest: (request, print) => {
                const path = new URL(request.url).pathname

                if (
                    path?.startsWith('/main') ||
                    path?.startsWith('/_next') ||
                    path?.startsWith('/__next') ||
                    path?.startsWith('/static') ||
                    request.url.startsWith('https://fonts.gstatic.com') ||
                    request.url.startsWith(
                        'https://nominatim.openstreetmap.org',
                    ) ||
                    request.url.startsWith(
                        'https://a.tile.openstreetmap.org',
                    ) ||
                    request.url.startsWith(
                        'https://b.tile.openstreetmap.org',
                    ) ||
                    request.url.startsWith(
                        'https://c.tile.openstreetmap.org',
                    ) ||
                    request.url.startsWith('https://unpkg.com')
                )
                    return

                print.warning()
            },
        })
    }
}
